import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DocumentNotification} from '../models/document-notification';
import {Document} from '../models/document';
import {AuthenticationService} from '../authenticationModule/services/authentication.service';
import {DocumentDownloadLog} from '../models/DocumentDownloadLog';
import {Observable} from 'rxjs';

@Injectable()
export class DocumentService {
  successSendNotification = false;
  fileNotFound = false;
  displayNotificationNewButton = false;
  downloadInitiated = false;


  constructor(private httpClient: HttpClient, public authenticationService: AuthenticationService) {
  }

  getDownloadedDocuments() {
    return this.httpClient.get<DocumentDownloadLog[]>(environment.baseUrlWs + '/api/document-download-log-list');
  }

  getDocuments() {
    return this.httpClient.get<Document[]>(environment.baseUrlWs + '/api/documents');
  }

  getDocumentByUniqid(documentUniqid: string) {
    return this.httpClient.get<Document>(environment.baseUrlWs + '/api/documents?uniqid=' + documentUniqid);
  }

  addDocument(formData: FormData) {
    return this.httpClient.post(environment.baseUrlWs + '/api/add-document', formData);
  }

  updateDocument(uniqid: string, formData: FormData) {
    return this.httpClient.post(environment.baseUrlWs + '/api/update-document/' + uniqid, formData);
  }

  deleteDocument(uniqid: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/delete-document/' + uniqid);
  }

  undeleteDocument(uniqid: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/undelete-document/' + uniqid);
  }

  downloadDocumentFile(uniqid: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/download-document/' + uniqid, {responseType: 'arraybuffer'});
  }

  getUsersNotificationDocument(uniqid: string) {
    return this.httpClient.get(environment.baseUrlWs + '/api/documents-users-notification/' + uniqid);
  }

  sendNotificationToClients(uniqid: string, documentNotification: DocumentNotification) {
    return this.httpClient.post(environment.baseUrlWs + '/api/send-notification/' + uniqid, documentNotification);
  }

  getDocumentMaxSizeMimeTypes() {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/document-max-size-mime-types');
  }

  getEmailFooter() {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/email-footer');
  }

  exportAsExcel(): Observable<any[]> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/document-export');
  }

  watchDocument(document: any) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/document/watch?id=' + document.uniqid);
  }

  unwatchDocument(document: any) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/document/unwatch?id=' + document.uniqid);
  }

  getUsersWatchedDocumentList() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/document/watch-list');
  }

  getNumberOfWatchersByDocument() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/document/ng-watchers');
  }

  subscribeToReport() {
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/document/subscribe', {});
  }

  unSubscribeFromReport() {
    return this.httpClient.post<any>(environment.baseUrlWs + '/api/document/unsubscribe', {});
  }
}
